module.exports = __webpack_public_path__ + "img/handraw_moins orange.e92ce5b5.svg";